module.exports = __webpack_public_path__ + "static/skitrip3-c6439c481f94851dde2fc257d1999beb.png";